import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetSpeakerWave2: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 9H3v6h3l5 5V4L6 9zm10-1a5 5 0 010 8m2.5-12a9 9 0 010 16" />
      </svg>
    </div>
  );
};

export default WidgetSpeakerWave2;
